export default {
  // base colors
  black: '#000000',
  white: '#ffffff',
  whiteOverlay: 'rgba(255, 255, 255, 0.6)', // dim layer for keep-data refetch loading state
  textSecondary: '#171D29',
  // color palletes
  blue0: '#3346AF',
  blue1: '#142151',
  blue2: '#5D6DB8',
  blue3: '#293B77',
  blue4: '#00B5DF',
  blue5: 'rgba(0, 181, 223, 0.08)',
  blue6: '#C5D9FF',
  blue7: '#1E68FC25',
  blue8: '#0072FF',
  blue9: '#DEF1FF',
  blue10: '#1E68FC',
  blue11: '#8dcee7',
  blue12: '#EEF4FF',
  blue13: '#0028E4',

  darkblue0: '#45526C',

  purple0: '#8b7fbf',
  purple1: '#d7cdf5',
  purple2: '#f3f0fc',

  grey0: '#e5e5e5',
  grey1: '#8c8582',
  grey2: '#6F6F6F',
  grey3: '#f8f8f8',
  grey4: '#f9f9f9',
  grey5: '#efefef',
  grey7: '#dddddd',
  grey8: '#C7C8CB',
  grey9: '#EDEDEE',
  grey10: '#C8C9CC',
  grey11: '#EEEEEE',
  grey12: '#F7F7F7',
  grey13: '#81858B',
  grey14: '#303030',
  grey15: '#f4f4f4',
  grey16: '#fff',
  grey17: '#f9f9f9',
  grey18: '#ddd',
  grey19: '#f1f1f1',

  red0: '#ef6354',
  red1: '#da2a52',
  red2: '#ffcfda80',
  red3: '#EA1A65',
  red4: '#ffcfda',
  red5: '#d9534f',

  yellow0: '#e3bd33',

  orange0: '#fa7325',

  green0: '#daffda',
  green1: '#11bb11',
  green2: '#00897B', // dashboard figures; also hardcoded in CardTotal's palette

  pink0: '#F185A7',

  black0: '#404040',
  black1: '#262626',
  black2: '#222222',
  black3: '#171D29',
  black4: 'rgba(38, 38, 38, 0.35)',
  black5: '#6A6C6E',
  black6: '#131313',

  transparent: 'transparent',

  pollingBannerBg: '#FFF8E1',
  pollingBannerBorder: '#FFC107',
  pollingBannerText: '#7A5E00',

  reminderBannerBg: '#FFF6F9',

  statusActiveBg: '#E6F4EA',
  statusInactiveBg: '#F0F0F0',
};
